/* eslint-disable react-hooks/exhaustive-deps */

import { getCategoriesDtv, getReasonsByCategoryId } from "../../services/CategoryService";
import { getSampleTypes } from "../../services/SampleTypesService";
import { getDepartments} from "../../services/DepartmentsService";
import { getDescriptors,getDescriptorsByJob} from "../../services/SweepDescriptorService";
import { getBySection } from "../../services/LookupService";
import { TextField, Select } from "@material-ui/core";
import DateFnsUtils from "@date-io/date-fns";
import { KeyboardDatePicker, MuiPickersUtilsProvider} from "@material-ui/pickers";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { SingleSelector } from "../SelectComponents";
import Multiselect from "multiselect-react-dropdown";
import Input from "@material-ui/core/Input";
import Chip from "@material-ui/core/Chip";
import { makeStyles } from "@material-ui/core/styles";
import MenuItem from "@material-ui/core/MenuItem";
import { TextareaAutosize } from "@mui/material";
import { Typography } from '@material-ui/core';
import UserService from '../../keycloak'
import { getAPItoken, getRealmUsers, getUserRoles, getUsersByRole, usersInRole,getUserProfiles } from '../../services/KeycloakAdminAPI'

/**
 * get all users, filter role requester and same lab
 */
const getRequesters= async () => 
	{
	let reqs=[];		 
	let depts=  new Map();		 
	// get list of users
//	let users=getUserProfiles();
	let users=	await getRealmUsers();
//	console.log(users);
	// check in roles and add in requester
	// create a map per department	
	for (var user of users)
	{
		if (user.attributes!=undefined && user.attributes["departments"]!=undefined)
		{
//			console.log(user.attributes["departments"]);
//			console.log(user.attributes["roles"]);
			for (var dept of user.attributes["departments"])
			{
				depts.set(user.email, dept);
			}
		}
		if (user.attributes!=undefined && user.attributes["roles"]!=undefined)
		{
			for (var role of user.attributes["roles"])
			{
				if ("DTV"==role)
				{
					reqs.push(user);		
				}
			}
		}
	}
	return {"reqs":reqs,"depts":depts};
	
}

function AddSweepJobPageOne(props) {

    const { shown, sweepJob, setSweepJob, setSaveBtnDisabled,setSaveBtnDisabledDTV, page, setPage } = props;

    const [category, setCategory] 		= useState({id: -1});
    const [name, setName] 				= useState("");
    const [dueDate, setDueDate] 			= useState(null);
	const [deptmap, setDeptmap] 			= useState([]);	
	const [descrmap, setDescrmap] 		= useState([]);	
    const [markets, setMarkets] 			= useState([]);
    const [brands, setBrands] 			= useState([]);
    const [subBrands, setSubBrands] 		= useState([]);
    const [sectors, setSectors] 			= useState([]);
    const [sizes, setSizes] 				= useState([]);
    const [packageType, setPackageType] 	= useState([]);
	const [descriptors, setDescriptors] 	= useState([]);
	const [descriptorsPerPackageType, setDescriptorsPerPackageType] = useState([]);
	const [marketsPerSector, setMarketsPerSector] = useState([]);
	const [subBrandsPerBrand, setSubBrandsPerBrand] = useState([]);
	
	const [departments, setDepartments] 		= useState([]);
	const [requesters, setRequesters] 		= useState([]);
    const [notes, setNotes] 					= useState("");
    const [allMarkets, setAllMarkets] 		= useState([]);
    const [allBrands, setAllBrands] 			= useState([]);
    const [allSubBrands, setAllSubBrands] 	= useState([]);
    const [allSectors, setAllSectors] 		= useState([]);
    const [allSizes, setAllSizes] 			= useState([]);
    const [allCategories, setAllCategories] 	= useState([]);
	const [allDescriptors, setAllDescriptors]= useState([]);

	const [department, setDepartment] = useState({ label: "select...", value: null })

	const [requester, setRequester] = useState({ label: "select...", value: null })
	const [requestersOpts, setRequestersOpts] = useState([])
   
    const { t } = useTranslation();

    const sections = ["MARKET", "BRAND", "SECTOR", "SIZE", "SUBBRAND"];

    const useStyles = makeStyles((theme) => ({
        root: {
            flex: 1,
            backgroundColor: "paper",
        },
        dialog: {
            width: "400px",
            display: "flex",
        },
        dialogBox: {
            alignItems: "center",
            display: "flex",
        },
        dialogText: {
            flex: "0.4",
        },
        dialogInput: {
            flex: "0.5",
        },
        chips: {
            display: "flex",
            flexWrap: "wrap",
        },
        chip: {
            margin: 2,
        },
        noLabel: {
            marginTop: theme.spacing(2),
            marginBottom: theme.spacing(2),
        },
        formControl: {
            minWidth: 120,
            maxWidth: 300,
        },
        testContainer: {
            display: "flex",
            columnGap: "5%",
            flexWrap: "wrap",
            alignItems: "center",
            width: "100%",
            rowGap: "0.5rem",
        },
    }));

    const classes = useStyles();




    useEffect(() => {
        if (shown) {
            getBySection(sections[0]).then((res) => {
                setAllMarkets(res);

                setSaveBtnDisabled(false);
            });

            getBySection(sections[1]).then((res) => {
                setAllBrands(res);

                setSaveBtnDisabled(false);
            });

            getBySection(sections[2]).then((res) => {
                setAllSectors(res);

                setSaveBtnDisabled(false);
            });

            getBySection(sections[3]).then((res) => {
                setAllSizes(res);

                setSaveBtnDisabled(false);
            });

            getBySection(sections[4]).then((res) => {
                setAllSubBrands(res);

                setSaveBtnDisabled(false);
            });
			getDepartments().then((res2) => {
			    setDepartments(res2)
            });
			getRequesters().then((res2) => {
			    setRequesters(res2["reqs"]);
				setDeptmap(res2["depts"]);
			});

            getCategoriesDtv().then((res) => {
                setAllCategories(res);

                setSaveBtnDisabled(false);
            });
			getDescriptors().then((res2) => {
//				console.log("GOT DESCRIPTORS ",res2);
			    setAllDescriptors(res2);
//////////////// organise descriptors by category
			
			
				let map= new Map();
				for (let i=0;i<res2.length;i++)
				{
					let desc=res2[i];
					let cats=desc.categories;
					for (let j=0;j<cats.length;j++)
					{
						let cat=cats[j];
						let mapEntry=map[cat.name];
						if ( mapEntry==undefined)
						{
							mapEntry=[];
							map[cat.name]=mapEntry;
						}
						mapEntry.push(desc);
					}
				}				
				console.log("MAP OF DESCRIPTORS",map);
//				console.log("AND CAT ",sweepJob.packageType,packageType);
				setDescrmap(map);
				if (sweepJob && sweepJob.packageType && sweepJob.packageType.id)
					{
						filterDescriptors(sweepJob.packageType);
					}				
				console.log("sweepJob.sectors ",sweepJob.sectors,sweepJob.brands );
					if (sweepJob && sweepJob.sectors && sweepJob.packageType.id)
						{
							filterMarkets(sweepJob.sectors );
						}				
						if (sweepJob && sweepJob.brands && sweepJob.packageType.id)
							{
								filterSubBrands(sweepJob.brands);
							}				
				
			});
			
				setSaveBtnDisabledDTV(UserService.hasRole(['DTV']));
			
        }
    }, [shown])


    useEffect(() => {
		
if (sweepJob) 
{
//	console.log("GENERAL ALL DESCR TO ",allDescriptors);
//	console.log("WITH LENGTH ",allDescriptors.length);
//	console.log("GENERAL CAT TO ",sweepJob.packageType);

	if (sweepJob.packageType && allDescriptors.length>0)
	{
		let ofPackageType= [...allDescriptors].filter(descr => descr.categories.some(item => item.id === sweepJob.packageType.id))
//		let selected = [...allMarkets].filter(market => sweepJob.markets.some(item => item.id === market.id))
		let selected = [];
		if (sweepJob.descriptors)
			{
				 selected = [...ofPackageType].filter(descr=> sweepJob.descriptors.some(item => item.id === descr.id))
			}
		else
			{
//				selected = ofPackageType;
			}
		setDescriptorsPerPackageType(ofPackageType );
		setDescriptors(selected );
	
	}
	

   if (allCategories.length > 0 && packageType.length === 0 && sweepJob.packageType) 
	{
		if(sweepJob.packageType.id)
		{	
			console.log("SET CAT TO ",sweepJob.packageType.id);
			setPackageType(sweepJob.packageType);
			console.log("MAP OF DESCRIPTORS IN CAT",descrmap);
		}
	}

            if (allMarkets.length > 0 && markets.length === 0 && sweepJob.markets && sweepJob.markets.length > 0) {
                let selected = [...allMarkets].filter(market => sweepJob.markets.some(item => item.id === market.id))

                setMarkets(selected);
            }

            if (allBrands.length > 0 && brands.length === 0 && sweepJob.brands && sweepJob.brands.length > 0) {
                let selected = [...allBrands].filter(brand => sweepJob.brands.some(item => item.id === brand.id))
				filterSubBrands(selected);            

                setBrands(selected);
            }

            if (allSubBrands.length > 0 && subBrands.length === 0 && sweepJob.subBrands && sweepJob.subBrands.length > 0) {
                let selected = [...allSubBrands].filter(subBrand => sweepJob.subBrands.some(item => item.id === subBrand.id))
                setSubBrands(selected);
            }

            if (allSectors.length > 0 && sectors.length === 0 && sweepJob.sectors && sweepJob.sectors.length > 0) {
                let selected = [...allSectors].filter(sector => sweepJob.sectors.some(item => item.id === sector.id))    ;
				filterMarkets(selected);            
                setSectors(selected);
            }

            if (allSizes.length > 0 && sizes.length === 0 && sweepJob.sizes && sweepJob.sizes.length > 0) {
                let selected = [...allSizes].filter(size => sweepJob.sizes.some(item => item.id === size.id))
                setSizes(selected);
            }
			if (departments.length > 0 && sweepJob.department) {
				departments.forEach((depart) => {
				    if (depart.name === sweepJob.department.name)
						{
					        setDepartment(depart);
						}
				});				
			}

			if (requesters.length > 0 && sweepJob.requester) {
				requesters.forEach((req) => {
//					console.log(" REQUESTER ",req.username);
				    if (req.username=== sweepJob.requester)
						{
					        setRequester(req);
						}
				});				
			}
			
			
            if (sweepJob.name) {
                setName(sweepJob.name);
            }

            if (sweepJob.dueDate) {
                setDueDate(sweepJob.dueDate);
            }

            if (sweepJob.notes) {
                setNotes(sweepJob.notes);
            }

            if (!page) setPage(1)
        }

    }, [sweepJob, allCategories,allDescriptors, allMarkets, allBrands, allSubBrands, allSectors, allSizes,departments, requesters,descrmap])




   
    useEffect(() => {
            sweepJob.sectors = sectors;
            sweepJob.jobChanged = true;
            storeSweepJob();
    }, [sectors]);

    useEffect(() => {
            sweepJob.markets = markets;
            sweepJob.jobChanged = true;
            storeSweepJob();
    }, [markets]);

    useEffect(() => {
            sweepJob.packageType = packageType;
            sweepJob.jobChanged = true;
            storeSweepJob();
    }, [packageType]);

    useEffect(() => {
            sweepJob.brands = brands;
            sweepJob.jobChanged = true;
            storeSweepJob();
    }, [brands]);

    useEffect(() => {
            sweepJob.subBrands = subBrands;
            sweepJob.jobChanged = true;
            storeSweepJob();
    }, [subBrands]);

    useEffect(() => {
            sweepJob.sizes = sizes;
            sweepJob.jobChanged = true;
            storeSweepJob();
    }, [sizes]);

	useEffect(() => {
	    if (department && department.value) {
			console.log("USE EFFECT SETTING department VALUE ",department);
	        sweepJob.department = department.value;
	        sweepJob.jobChanged = true;
	        storeSweepJob();
	    }
	}, [department])

	useEffect(() => {
	    if (requester && requester.value) {
	        sweepJob.requester  = requester.value.username ;
			sweepJob.requesterEmail  = requester.value.email;
	        sweepJob.jobChanged = true;
	        storeSweepJob();
	    }
	}, [requester])

	useEffect(() => {
	    if (deptmap) {
	        sweepJob.deptmap= deptmap;
	        sweepJob.jobChanged = true;
	        storeSweepJob();
	    }
	}, [deptmap])

	useEffect(() => {
	    if (requesters.length > 0) {
	        const opts = requesters.map((d) => { return { value: d, label: d.firstName+" "+d.lastName } })
	        setRequestersOpts(opts)
	    }
	}, [requesters])

    useEffect(() => {
        if (name) {
            sweepJob.name = name;
            sweepJob.jobChanged = true;
            storeSweepJob();
        }
    }, [name]);

    useEffect(() => {
        if (dueDate) {
            sweepJob.dueDate = dueDate;
            sweepJob.jobChanged = true;
            storeSweepJob();
        }
    }, [dueDate]);

    useEffect(() => {
        if (notes) {
            sweepJob.notes = notes;
            sweepJob.jobChanged = true;
            storeSweepJob();
        }
    }, [notes]);

	const handleRequesterChange= (requester)=> {
	    if (requester ) {
	        sweepJob.requester  = requester.username ;
	        sweepJob.jobChanged = true;
	        storeSweepJob();
	    }
	};
    

    const handleDueDateChange = (date) => {
        setDueDate(date);
    };

  
    const handleSectorsChange = (event) => {
		let selectedSectors=event.target.value;
        setSectors(selectedSectors);
		filterMarkets(selectedSectors);
		
    };

    const handleMarketsChange = (event) => {
        setMarkets(event.target.value)
    };

    const handleBrandsChange = (event) => {
        setBrands(event.target.value)
		filterSubBrands(event.target.value);
    };

    const handleSubBrandsChange = (event) => {
        setSubBrands(event.target.value)
    };

    const handleSizesChange = (event) => {
        setSizes(event.target.value)
    };

    const handleCategoriesChange = (event) => {
        setPackageType(event.target.value);
		console.log("handlepackageTypeChange ",event.target.value);
		filterDescriptors(event.target.value);
    };
	const handleDescriptorsChange = (event) => {
		console.log("DESCRIP CHANGE ",event.target.value);
	    setDescriptors(event.target.value)
	sweepJob.descriptors=event.target.value;
	console.log("DESCRIPTORS ",sweepJob.descriptors);

	};
	const filterDescriptors= (cat) => {
		if (cat.length>0) cat=cat[0];
		let selectedDesciptors=[];
		console.log("filterDescriptors cat:", cat.name);
		console.log("descrmap:", descrmap);
		selectedDesciptors=descrmap[cat.name];
		if (selectedDesciptors==undefined || selectedDesciptors.length==0) return;

			
	    setDescriptorsPerPackageType(selectedDesciptors );
		console.log("sweepJob selectedDescriptors ", descriptorsPerPackageType);
	};

	const filterMarkets= (selectedSectors) => {
				let selectedMarkets=[];
				console.log("SELECTED SECTORS",selectedSectors);
				if (selectedSectors.length>0)
				{
						for (let i=0;i<selectedSectors.length;i++)
						{
							let selectedSector=selectedSectors[i].name;
							console.log("selectedSector", selectedSector);
							for (let j=0;j<allMarkets.length;j++)
							{
		//						console.log()
								if (allMarkets[j].parent==selectedSector)
								{
									selectedMarkets.push(allMarkets[j])	;	
								}
							}						
						}
					console.log("ALL Markets", allMarkets);
					console.log("Markets per sector", selectedMarkets);
					if (selectedMarkets==undefined || selectedMarkets.length==0) return;
					setMarketsPerSector(selectedMarkets);
					}

	};

	const filterSubBrands= (selectedBrands) => {
				let selectedSubBrands=[];
				console.log("SELECTED BRANDS",selectedBrands);
				if (selectedBrands.length>0)
				{
						for (let i=0;i<selectedBrands.length;i++)
						{
							let selectedBrand=selectedBrands[i].name;
							console.log("selectedBrand", selectedBrand);
							for (let j=0;j<allSubBrands.length;j++)
							{
								if (allSubBrands[j].parent==selectedBrand)
								{
									selectedSubBrands.push(allSubBrands[j])	;	
								}
							}						
						}
					console.log("selectedSubBrands per Brand", selectedSubBrands);
					if (selectedSubBrands==undefined || selectedSubBrands.length==0) return;
					setSubBrandsPerBrand(selectedSubBrands);
					}

	};

	    const handleNameChange = (event) => {
        setName(event.target.value)
    };

    const handleNotesChange = (event) => {
        setNotes(event.target.value)
    };

	const handleDepartmentChange = (event) => {
	    setDepartment(event.target.value)
	};

    const storeSweepJob = () => {
		if (sweepJob.department)
		{
			var thisDept=sweepJob.department.name;
			var dep='';
			if (deptmap)
			{
				for (let [key, value] of deptmap.entries())
				{
					if (value==thisDept)
					{
						dep=dep+key+";";		
					}		
				}		
				sweepJob.recipients=dep;
			}		
		}
        setSweepJob(JSON.parse(JSON.stringify(sweepJob)))
    }
   
    if (shown) return (
        <div>
            <h2>Sweep Job Details</h2>
            <table  style={{width:"100%"}}>
                <tr>
                    <td style={{ padding: "20px", verticalAlign: "top", display: "flex", flexDirection: "column"}}>                        
					
                        <div>ID: 
						{!name &&
							<Typography variant="body1" className={classes.dialogText}>
						    <em style={{ color: "grey" }}>DTV Request ID will be created upon saving</em>
						</Typography>
						}
						{name &&
						<Typography variant="body1" className={classes.dialogText}>
						    {name}
						</Typography>
						}
						</div>
                        <div style={{ marginTop: "20px", marginBottom: "5px" }}>Due Date:<span style={{ color: "red" }}>*</span> </div>                        
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                <KeyboardDatePicker
                                    disableToolbar
                                    variant="inline"
                                    margin="normal"
                                    id="date-picker-inline"
                                    label={"Set " + t("due_date_label")}
                                    value={sweepJob.dueDate}
                                    onChange={handleDueDateChange}      
                                    disablePast
                                    // InputProps={{style: {width: "20vw"}}}
                                    KeyboardButtonProps={{"aria-label": "change date",}}
                                />
                        </MuiPickersUtilsProvider>


                        <div style={{ marginTop: "20px", marginBottom: "5px" }}>Sector:<span style={{ color: "red" }}>*</span></div>

                        <Select
                            multiple
                            required
                            displayEmpty
                            // disabled={editDisabled}
                            value={sectors}
                            onChange={handleSectorsChange}
                            input={<Input />}
                            renderValue={(selected) => {
                                if (selected.length === 0) {
                                    return <em style={{ color: "grey" }}>{t("Select all that apply")}...</em>;
                                }

                                return (
                                    <div className={classes.chips}>
                                        {selected.map((value) => (
                                            <Chip
                                                key={value.id}
                                                label={value.name}
                                                className={classes.chip}
                                            />
                                        ))}
                                    </div>
                                );
                            }}
                            inputProps={{ "aria-label": "Without label" }}>
                            {allSectors.map((equipment) => (
                                <MenuItem key={equipment.id} value={equipment}>
                                    {equipment.name}
                                </MenuItem>
                            ))}
                        </Select>

                        <div style={{ marginTop: "20px", marginBottom: "5px" }}>Market:<span style={{ color: "red" }}>*</span> </div>

                        <Select
                            multiple
                            required
                            displayEmpty
                            // disabled={editDisabled}
                            value={markets}
                            onChange={handleMarketsChange}
                            input={<Input />}
                            renderValue={(selected) => {
                                if (selected.length === 0) {
                                    return <em style={{ color: "grey" }}>{t("Select all that apply")}...</em>;
                                }

                                return (
                                    <div className={classes.chips}>
                                        {selected.map((value) => (
                                            <Chip
                                                key={value.id}
                                                label={value.name}
                                                className={classes.chip}
                                            />
                                        ))}
                                    </div>
                                );
                            }}
                            inputProps={{ "aria-label": "Without label" }}>
                            {marketsPerSector.map((equipment) => (
                                <MenuItem key={equipment.id} value={equipment}>
                                    {equipment.name}
                                </MenuItem>
                            ))}
                        </Select>

                        <div style={{ marginTop: "20px", marginBottom: "5px" }}>Package Type:<span style={{ color: "red" }}>*</span> </div>

                        <Select
 //                           multiple
                            required
                            displayEmpty
                            // disabled={editDisabled}
                            value={packageType}
                            onChange={handleCategoriesChange}
                            input={<Input />}
                            renderValue={(selected) => {
                                if (selected.length === 0) {
                                    return <em style={{ color: "grey" }}>{t("Select Package Type")}...</em>;
                                }

                                return (
                                    <div className={classes.chips}>
                                        {
                                            <Chip
                                                key={selected.id}
                                                label={selected.name}
                                                className={classes.chip}
                                            />
                                        }
                                    </div>
                                );
                            }}
                            inputProps={{ "aria-label": "Without label" }}>
                            {allCategories.map((category) => (
                                <MenuItem key={category.id} value={category}>
                                    {category.name}
                                </MenuItem>
                            ))}
                        </Select>

                        <div style={{ marginTop: "20px", marginBottom: "5px" }}>Own Brand:<span style={{ color: "red" }}>*</span> </div>

                        <Select
                            multiple
                            required
                            displayEmpty
                            // disabled={editDisabled}
                            value={brands}
                            onChange={handleBrandsChange}
                            input={<Input />}
                            renderValue={(selected) => {
                                if (selected.length === 0) {
                                    return <em style={{ color: "grey" }}>{t("Select all that apply")}...</em>;
                                }

                                return (
                                    <div className={classes.chips}>
                                        {selected.map((value) => (
                                            <Chip
                                                key={value.id}
                                                label={value.name}
                                                className={classes.chip}
                                            />
                                        ))}
                                    </div>
                                );
                            }}
                            inputProps={{ "aria-label": "Without label" }}>
                            {allBrands.map((equipment) => (
                                <MenuItem key={equipment.id} value={equipment}>
                                    {equipment.name}
                                </MenuItem>
                            ))}
                        </Select>

                        <div style={{ marginTop: "20px", marginBottom: "5px" }}>Sub Brands:<span style={{ color: "red" }}>*</span> </div>

                        <Select
                            multiple
                            required
                            displayEmpty
                            // disabled={editDisabled}
                            value={subBrands}
                            onChange={handleSubBrandsChange}
                            input={<Input />}
                            renderValue={(selected) => {
                                if (selected.length === 0) {
                                    return <em style={{ color: "grey" }}>{t("Select all that apply")}...</em>;
                                }

                                return (
                                    <div className={classes.chips}>
                                        {selected.map((value) => (
                                            <Chip
                                                key={value.id}
                                                label={value.name}
                                                className={classes.chip}
                                            />
                                        ))}
                                    </div>
                                );
                            }}
                            inputProps={{ "aria-label": "Without label" }}>
                            {subBrandsPerBrand.map((subbrand) => (
                                <MenuItem key={subbrand.id} value={subbrand}>
                                    {subbrand.name}
                                </MenuItem>
                            ))}
                        </Select>

                        <div style={{ marginTop: "20px", marginBottom: "5px" }}>Selection of Sizes:<span style={{ color: "red" }}>*</span> </div>

                        <Select
                            multiple
                            required
                            displayEmpty
                            // disabled={editDisabled}
                            value={sizes}
                            onChange={handleSizesChange}
                            input={<Input />}
                            renderValue={(selected) => {
                                if (selected.length === 0) {
                                    return <em style={{ color: "grey" }}>{t("Select all that apply")}...</em>;
                                }

                                return (
                                    <div className={classes.chips}>
                                        {selected.map((value) => (
                                            <Chip
                                                key={value.id}
                                                label={value.name}
                                                className={classes.chip}
                                            />
                                        ))}
                                    </div>
                                );
                            }}
                            inputProps={{ "aria-label": "Without label" }}>
                            {allSizes.map((size) => (
                                <MenuItem key={size.id} value={size}>
                                    {size.name}
                                </MenuItem>
                            ))}
                        </Select>

						
						<div style={{ marginTop: "20px", marginBottom: "5px" }}>Descriptors:<span style={{ color: "red" }}>*</span> </div>

						<Select
						    multiple
						    required
						    displayEmpty
						    // disabled={editDisabled}
						    value={descriptors}
						    onChange={handleDescriptorsChange}
						    input={<Input />}
						    renderValue={(selected) => {
						        if (selected.length === 0) {
						            return <em style={{ color: "grey" }}>{t("Select all descriptors that apply")}...</em>;
						        }

						        return (
						            <div className={classes.chips}>
						                {selected.map((value) => (
						                    <Chip
						                        key={value.id}
						                        label={value.name}
						                        className={classes.chip}
						                    />
						                ))}
						            </div>
						        );
						    }}
						    inputProps={{ "aria-label": "Without label" }}>
						    {descriptorsPerPackageType.map((descriptor) => (
						        <MenuItem key={descriptor.id} value={descriptor}>
						            {descriptor.name}
						        </MenuItem>
						    ))}
						</Select>

						
						

						<div style={{ marginTop: "30px" }}>{t("Department")}:</div>
						<SingleSelector
						onChange={handleDepartmentChange}	    width="21vw"
							options={departments.map((c) => ({ value: c, label: c.name }))}
							value={ { value: department, label: department.name } }
						    placeholder="Select Department..."
						    handleSelect={(opt) => { setDepartment(opt) }} />

						

							<div style={{ marginTop: "30px" }}>{t("Requester")}:</div>
							<SingleSelector
							onChange={handleRequesterChange} width="21vw"
								options={requesters.map((c) => ({ value: c, label: c.firstName+" "+c.lastName  }))}
								value={ { value: requester, label: requester.firstName+" "+requester.lastName } }
							    placeholder="Select Requester..."
							    handleSelect={(opt) => { setRequester(opt) }} />

                        <div style={{ marginTop: "20px", marginBottom: "5px" }}>Notes: </div>

                        <TextareaAutosize
                            value={notes}
                            onChange={handleNotesChange}
                            id="notes"
                            placeholder="Enter Notes..."
                        >
                        </TextareaAutosize>
                    </td>
                </tr>
            </table>
        </div>
    );
    else return <></>
}



export default AddSweepJobPageOne;





